import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss']
})
export class AlertDialogComponent implements OnInit {
  title:any;
  message:any;
  status:any;
  btnClass:any;
  textOnBtn:any;
  isConfrim:boolean = false;
  remarks:any;
  hasRemark:boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<any>) { }

  ngOnInit(): void {
    console.log(this.data);
    this.message = this.data['message'];
    this.title = this.data['title'];
    this.status = this.data['status'] || 'success';
    this.textOnBtn = this.data['btnText'] || 'Close';
    this.isConfrim = this.data['isConfrim'] || false;
    this.hasRemark = this.data['hasRemark'] || false;

    switch(this.status){
      case 'success': { this.btnClass='success'} break;
      case 'warn': {this.btnClass='warn'}break;
      case 'error':{this.btnClass='accent'}break;
    }
  }

  submit(){
    if(this.isConfrim){
      this.dialogRef.close({remarks:this.remarks,status:true});
    }
    else{
      this.dialogRef.close();
    }
  }

}
